import { resolveStaticAssetUrl } from '~/utils/resolveStaticAssetUrl'

/**
 * URL for this app's own bundled static/marketing assets (favicon, hero
 * images, auth-page backgrounds, brand logo). Origin is fully
 * configuration-driven via NUXT_PUBLIC_STATIC_ASSETS_ORIGIN -- no storage
 * vendor is hardcoded here or at any call site.
 */
export const useStaticAssetUrl = (path: string): string =>
  resolveStaticAssetUrl(useRuntimeConfig().public.staticAssetsOrigin, path)
